import { type WalletFrontTransferOutRequest } from '@capsicum/common';
import { useMutation } from '@tanstack/react-query';

import { postWalletTransferOut } from '../data-access/api';

/**
 * @returns withdraw action
 */
export const useWalletWithdrawPost = () =>
	useMutation({ mutationFn: (payload: WalletFrontTransferOutRequest) => postWalletTransferOut(payload) });
